import { coreApi } from './core.js';
import { blockchainApi, calculateTPS } from './blockchain.js';
import { optimizedBlockchainApi, calculateTPS as optimizedCalculateTPS } from './optimized-blockchain.js';
import { accountsApi } from './accounts.js';
import { 
  isContractVerified,
  getContractDetails,
  getContractAbi,
  getContractSource,
  getContractEvents,
  verifyContract,
  interactWithContract,
  callContractMethod,
  processABI
} from './contracts.js';
import {
  getTokenInfo,
  getTokenTransfers,
  getTokenHolders,
  getNftCollections,
  getNftCollection,
  getNftToken
} from './tokens.js';
import blockchainAIApi from './blockchainAI.js';

// Performance mode configuration - Temporarily use regular mode
const PERFORMANCE_MODE = 'regular'; // Temporarily use regular mode for debugging

// Choose the appropriate blockchain API based on performance mode
const activeBlockchainApi = PERFORMANCE_MODE === 'optimized' ? optimizedBlockchainApi : blockchainApi;
const activeCalculateTPS = PERFORMANCE_MODE === 'optimized' ? optimizedCalculateTPS : calculateTPS;

console.log(`🚀 Using ${PERFORMANCE_MODE} API mode for better performance`);

// Combine all API modules into a single API service
const apiService = {
  // Core API functions
  ...coreApi,
  
  // Blockchain API functions (using active/optimized version)
  ...activeBlockchainApi,
  
  // Accounts API functions
  ...accountsApi,
  
  // Contract API functions
  isContractVerified,
  getContractDetails,
  getContractAbi,
  getContractSource,
  getContractEvents,
  verifyContract,
  interactWithContract,
  callContractMethod,
  processABI,
  
  // Token and NFT API functions
  getTokenInfo,
  getTokenTransfers,
  getTokenHolders,
  getNftCollections,
  getNftCollection,
  getNftToken,
  
  // AI Dashboard data - explicitly use the one from blockchainAI.js
  getAiDashboardData: blockchainAIApi.getAiDashboardData,
  
  // Debug function to get the base URL
  getBaseUrl: () => coreApi.getBaseUrl(),
  
  // Performance utilities (only available in optimized mode)
  ...(PERFORMANCE_MODE === 'optimized' ? {
    clearCache: activeBlockchainApi.clearCache,
    getCacheStats: activeBlockchainApi.getCacheStats,
    setPerformanceMode: (mode) => {
      console.log(`Switching to ${mode} mode - requires page refresh`);
      if (typeof window !== 'undefined') {
        window.localStorage.setItem('performanceMode', mode);
      }
    }
  } : {})
};

// Export the combined API service as the default export
export default apiService;

// Also export individual modules for direct access if needed
export {
  coreApi,
  blockchainApi,
  accountsApi,
  calculateTPS,
  isContractVerified,
  getContractDetails,
  getContractAbi,
  getContractSource,
  getContractEvents,
  verifyContract,
  interactWithContract,
  callContractMethod,
  processABI
};
